module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAAAXNSR0IArs4c6QAAAOpJREFUGBljrKqqEv/582etvLx8cV5e3k8GLKChoYHj8+fPk5mYmGqZfv369QWoxvXBgwdTsagFCwEVzwIybP7///+Z+dixY79tbW33AjkTLC0tPx0/fvw0ssbi4uJCID+dmZnZpbu7+zkzSPLo0aNvrK2trwGZc6ysrA4BNT0EiRcVFTkDqQVAp4QBFR8HiTGCCBgoKSlpANqUCcQmQEUsQPo0EPf39fW1wtSgaABKMgI1bQBKSgMxKxDf6unpCWNkZPwP08AEY4BokAQvL28skMkN0gwECciKkdWisIHBKFBeXs6PIgjlAADLZmGKdC/uvQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/Settings/img/switch.png
// module id = 1739
// module chunks = 0